module.exports = __webpack_public_path__ + "static/media/98.f258114a.jpg";